<h1 i18n>Conversions</h1>
<div class="line">
  <mat-form-field class="line-full">
    <mat-label>Filter by Filename</mat-label>
    <input matInput [ngModel]="fileNameFilter()" (ngModelChange)="onFileNameFilter($event)">
  </mat-form-field>
  <mat-form-field class="line-part">
    <mat-label>Filter by SourceType</mat-label>
    <mat-select [ngModel]="selectedSourceType()" (ngModelChange)="selectedSourceType.set($event)" (selectionChange)="changeSourceType($event.value)">
      <mat-option [value]="null">All</mat-option>
      @for (conversionDataType of conversionDataTypeList; track conversionDataType) {
        <mat-option [value]="conversionDataType">
          {{conversionDataType}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="line-part">
    <mat-label>Filter by DestinationType</mat-label>
    <mat-select [ngModel]="selectedDestinationType()" (ngModelChange)="selectedDestinationType.set($event)" (selectionChange)="changeDestinationType($event.value)">
      <mat-option [value]="null">All</mat-option>
      @for (conversionDataType of conversionDataTypeList; track conversionDataType) {
        <mat-option [value]="conversionDataType">
          {{conversionDataType}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<da-multi-select-client
  class="full-width"
  label="Filter by Client"
  placeholder="Pick client..."
  [list]="clients()"
  (selectingChange)="filterClients($event)"
  >
</da-multi-select-client>

<da-multi-select-client
  class="full-width"
  label="Excluded Clients"
  placeholder="Pick client..."
  [list]="clients()"
  (selectingChange)="excludedClients($event)"
  >
</da-multi-select-client>

<mat-table [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
  <ng-container matColumnDef="durationInMs">
    <mat-header-cell mat-sort-header *matHeaderCellDef> Duration </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.durationInMs}} ms </mat-cell>
  </ng-container>
  <ng-container matColumnDef="runAtUtc">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Run at </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.runAtUtc | date: 'dd.MM.yyyy HH:mm'}} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="fileName">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Filename </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.fileName }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="clientName">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Client </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.clientName }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="sourceType">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Source Type </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.sourceType }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="destinationType">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Destination </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.destinationType }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="sourceGaebProgName">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Source Prog Name </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.sourceGaebProgName }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="sourceGaebProgSystem">
    <mat-header-cell mat-sort-header *matHeaderCellDef i18n> Source Prog System </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.sourceGaebProgSystem }} </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="['durationInMs', 'runAtUtc', 'fileName', 'clientName', 'sourceType', 'destinationType', 'sourceGaebProgName', 'sourceGaebProgSystem']"></mat-header-row>
  <mat-row (click)="showDetail(row)" *matRowDef="let row; columns: ['durationInMs', 'runAtUtc', 'fileName', 'clientName', 'sourceType', 'destinationType', 'sourceGaebProgName', 'sourceGaebProgSystem'];"></mat-row>
</mat-table>
@if (conversionInfosPaginated()) {
  <mat-paginator [length]="conversionInfosPaginated().totalCount" [pageSize]="conversionInfosService.pageSize"
    [pageIndex]="conversionInfosService.page -1" [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPage($event)">
  </mat-paginator>
}
